import { render, staticRenderFns } from "./DirectionsHowWeWorkBlock.vue?vue&type=template&id=0146a8fa&scoped=true&"
import script from "./DirectionsHowWeWorkBlock.vue?vue&type=script&lang=js&"
export * from "./DirectionsHowWeWorkBlock.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsHowWeWorkBlock.vue?vue&type=style&index=0&id=0146a8fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146a8fa",
  null
  
)

export default component.exports